import { defineMessages } from "@formatjs/intl";

const PREFIX = "lms.guide03.mixing-slide";
export const messages = defineMessages({
  title: {
    id: `${PREFIX}.title`,
  },
  accordionItem1Title: {
    id: `${PREFIX}.accordion-item1.title`,
  },
  accordionItem1Description: {
    id: `${PREFIX}.accordion-item1.description`,
  },
  accordionItem2Title: {
    id: `${PREFIX}.accordion-item2.title`,
  },
  accordionItem2Description: {
    id: `${PREFIX}.accordion-item2.description`,
  },
  accordionItem3Title: {
    id: `${PREFIX}.accordion-item3.title`,
  },
  accordionItem3Description: {
    id: `${PREFIX}.accordion-item3.description`,
  },
  accordionItem4Title: {
    id: `${PREFIX}.accordion-item4.title`,
  },
  accordionItem4Description: {
    id: `${PREFIX}.accordion-item4.description`,
  },
  accordionItem5Title: {
    id: `${PREFIX}.accordion-item5.title`,
  },
  accordionItem5Description: {
    id: `${PREFIX}.accordion-item5.description`,
  },
  accordionItem6Title: {
    id: `${PREFIX}.accordion-item6.title`,
  },
  accordionItem6Description: {
    id: `${PREFIX}.accordion-item6.description`,
  },
  accordionItem7Title: {
    id: `${PREFIX}.accordion-item7.title`,
  },
  accordionItem7Description: {
    id: `${PREFIX}.accordion-item7.description`,
  },
  accordionItem8Title: {
    id: `${PREFIX}.accordion-item8.title`,
  },
  accordionItem8Description: {
    id: `${PREFIX}.accordion-item8.description`,
  },
  bedsSlideTitle: {
    id: `${PREFIX}.beds-slide.title`,
  },
  bedsSlideDescription: {
    id: `${PREFIX}.beds-slide.description1`,
  },
  bedsSlideDescription2: {
    id: `${PREFIX}.beds-slide.description2`,
  },
  panningSlideTitle: {
    id: `${PREFIX}.panning-slide.title`,
  },
  panningSlideDescription1: {
    id: `${PREFIX}.panning-slide.description1`,
  },
  panningSlideDescription2: {
    id: `${PREFIX}.panning-slide.description2`,
  },
  reverbSlideTitle: {
    id: `${PREFIX}.reverb-slide.title`,
  },
  reverbSlideDescription1: {
    id: `${PREFIX}.reverb-slide.description1`,
  },
  reverbSlideDescription2: {
    id: `${PREFIX}.reverb-slide.description2`,
  },
  reverbSlideDescription3: {
    id: `${PREFIX}.reverb-slide.description3`,
  },
  reverbSlideTitle2: {
    id: `${PREFIX}.reverb-slide.title2`,
  },
  dialogueSlideTitle: {
    id: `${PREFIX}.dialogue-slide.title`,
  },
  dialogueSlideDescription: {
    id: `${PREFIX}.dialogue-slide.description`,
  },
  loudnessSlideTitle: {
    id: `${PREFIX}.loudness-slide.title`,
  },
  loudnessSlideDescription: {
    id: `${PREFIX}.loudness-slide.description`,
  },
  loudnessSlideDescription2: {
    id: `${PREFIX}.loudness-slide.description2`,
  },
  loudnessSlideTitle2: {
    id: `${PREFIX}.loudness-slide.title2`,
  },
  lfeSlideTitle: {
    id: `${PREFIX}.lfe-slide.title`,
  },
  lfeSlideDescription: {
    id: `${PREFIX}.lfe-slide.description`,
  },
  lfeSlideTitle2: {
    id: `${PREFIX}.lfe-slide.title2`,
  },
  lfeSlideDescription2: {
    id: `${PREFIX}.lfe-slide.description2`,
  },
  speakersSlideTitle: {
    id: `${PREFIX}.speakers-slide.title`,
  },
  speakersSlideDescription: {
    id: `${PREFIX}.speakers-slide.description`,
  },
  speakersSlideTitle2: {
    id: `${PREFIX}.speakers-slide.title2`,
  },
  speakersSlideDescription2: {
    id: `${PREFIX}.speakers-slide.description2`,
  },
  heightSlideTitle: {
    id: `${PREFIX}.height-slide.title`,
  },
  heightSlideDescription: {
    id: `${PREFIX}.height-slide.description`,
  },
  heightSlideDescription2: {
    id: `${PREFIX}.height-slide.description2`,
  },
  heightSlideDescription3: {
    id: `${PREFIX}.height-slide.description3`,
  },
  heightSlideDescription4: {
    id: `${PREFIX}.height-slide.description4`,
  },
  heightSlideDescription5: {
    id: `${PREFIX}.height-slide.description5`,
  },
  heightSlideDescription6: {
    id: `${PREFIX}.height-slide.description6`,
  },
  heightSlideDescription7: {
    id: `${PREFIX}.height-slide.description7`,
  },
  heightSlideDescription8: {
    id: `${PREFIX}.height-slide.description8`,
  },
  heightSlideDescription9: {
    id: `${PREFIX}.height-slide.description9`,
  },
  heightSlideOption: {
    id: `${PREFIX}.height-slide.option`,
  },
});
